import { jsxs, jsx } from "react/jsx-runtime";
import { IconArrowRight } from "../ConciergeIcons.js";
import { useState } from "react";
const SubmitButton = ({
  disabled,
  isStreaming = false,
  onStop,
  styles,
  resolveColor
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const isDisabled = !isStreaming && disabled;
  const bgColor = resolveColor(styles.submitButtonBgColor);
  const backgroundColor = isHovered ? resolveColor(styles.submitButtonBgColorHover) : bgColor;
  const iconColor = resolveColor(styles.submitButtonIconColor);
  const handleClick = (e) => {
    if (isStreaming && onStop) {
      e.preventDefault();
      onStop();
    }
  };
  const size = styles.submitButtonSize;
  return /* @__PURE__ */ jsxs(
    "button",
    {
      type: isStreaming ? "button" : "submit",
      disabled: isDisabled,
      onClick: handleClick,
      "aria-label": isStreaming ? "Stop generating" : "Submit",
      "data-concierge-submit": true,
      className: "tw:flex tw:items-center tw:justify-center tw:cursor-pointer disabled:tw:cursor-not-allowed",
      style: {
        width: size,
        height: size,
        position: "relative",
        border: "none",
        borderRadius: styles.submitButtonBorderRadius,
        background: "transparent",
        padding: 0
      },
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      children: [
        /* @__PURE__ */ jsx(
          "span",
          {
            style: {
              position: "absolute",
              inset: 0,
              borderRadius: styles.submitButtonBorderRadius,
              backgroundColor,
              opacity: isDisabled ? 0.1 : 1,
              transition: "background-color 0.15s ease, opacity 0.15s ease",
              pointerEvents: "none"
            }
          }
        ),
        /* @__PURE__ */ jsx(
          "span",
          {
            style: {
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            children: isStreaming ? /* @__PURE__ */ jsx(
              "div",
              {
                style: {
                  width: Math.round(size / 3),
                  height: Math.round(size / 3),
                  borderRadius: 1,
                  backgroundColor: "#FFFFFF"
                }
              }
            ) : /* @__PURE__ */ jsx(
              IconArrowRight,
              {
                size: size / 2,
                style: {
                  color: isDisabled ? bgColor : iconColor,
                  opacity: isDisabled ? 0.5 : 1,
                  transition: "color 0.15s ease, opacity 0.15s ease"
                }
              }
            )
          }
        )
      ]
    }
  );
};
export {
  SubmitButton
};
//# sourceMappingURL=SubmitButton.js.map
